import { Inject, Injectable } from "@angular/core";
import { DwOrmDataService, DwOrmDataServiceToken, getParameterByName } from "@devwareapps/devware-cap";
import * as moment_ from 'moment';
import { Router } from '@angular/router';
import { Observable } from "rxjs";
const moment = moment_;

@Injectable()
export class QueryString {
    constructor(private router: Router) {
    }

    getString(param: string) : string {
        const data = getParameterByName(this.router, param);
        return data;
    }
    exists(param: string) : boolean {
        const data = getParameterByName(this.router, param);
        return data != undefined;
    }
   
}